import { CoSyncDB, IMigration } from '@/renderer/scripts/CoSync/SyncCenter/Repo/CoSyncDB';

export default class CoSyncMigrationDAO {
  private db: CoSyncDB;

  constructor(db: CoSyncDB) {
    this.db = db;
  }

  public async add(record: IMigration): Promise<number> {
    return this.db.migration.add(record);
  }

  public async getAll(): Promise<IMigration[]> {
    return await this.db.migration.toArray();
  }
}
